import GlassSvg from "../images/glass_logo.svg";
import PanchoFace from "../images/pancho_w_border.png";
import RedstoneComputer from '../images/redstone-computer.png'
import styles from "../Style"
import {createUseStyles} from "react-jss";
import useMobile from "../../../template/Mobile";
const useStyle = createUseStyles(styles)

export default function TechnicalWork() {
    const style = useStyle();
    const isMobile = useMobile();
    return <div>
        <div className={style.portfolioSectionHorizontalFlex}>
            <div className={isMobile ? style.mobilePortfolioFlexSubsection : style.portfolioFlexSubsection}>
                <h3 id={"glass-project"}><a href={"https://glass-project.com/home"} target={"_blank"}>GLASS</a></h3>
                <p>📅 December 2023 - December 2024</p>
                <ul>
                    <li>Bachelor's degree capstone project</li>
                    <li>Created a LR1 parser generator and scripting
                        system from the ground up in Java
                    </li>
                    <li>The tool allows users to create their own
                        small-scale interpreted programming
                        languages.
                    </li>
                    <li>Created and maintained a website for the
                        project, available at <a href={"https://glass-project.com/home"}
                                                 target={"_blank"}>glass-project.com</a>
                    </li>
                </ul>

            </div>
            <img src={GlassSvg} alt={"GLASS Logo"}/>
        </div>
        <div className={style.portfolioSectionHorizontalFlex}>
            <div className={isMobile ? style.mobilePortfolioFlexSubsection : style.portfolioFlexSubsection}>
                <h3>Medical Image Reconstruction and Simulation</h3>
                <p>📅 July 2023 - December 2024</p>
                <ul>
                    <li>Experience gained during <a onClick={() => {
                        const element = document.getElementById('mitraLabWorkExperience')
                        element?.scrollIntoView({behavior: 'smooth'})
                    }}>my time working under Dr. Mitra</a></li>
                    <li>Used Geant4, then later OpenGATE, to create both PET and SPECT imaging simulations</li>
                    <li>Made use of TensorFlow, then later PyTorch, to build ANNs that would reconstruct the original
                        imaging data from the data generated by these simulations
                    </li>
                </ul>
            </div>
        </div>

        <div className={style.portfolioSectionHorizontalFlex}>
            { isMobile ? null : <img src={RedstoneComputer}/> }
            <div className={isMobile ? style.mobilePortfolioFlexSubsection : style.portfolioFlexSubsection}>
                <h3><a href={'https://www.youtube.com/watch?v=uEz5tKJs4NU'}>Redstone 8-Bit Computer</a></h3>
                <p>📅 March 2021</p>
                <ul>
                    <li>A programmable, fully functional 8-bit computer made in Minecraft</li>
                    <li>Contains a program memory, program counter, 16 bytes of RAM, an ALU, a custom instruction
                        set, and a user interface made of buttons and levers
                    </li>
                    <li>Using my <a onClick={() => {
                        const element = document.getElementById("glass-project")
                        element?.scrollIntoView({behavior: 'smooth'})
                    }}>degree capstone project</a>, I was able to write a tool to assist in programming
                        the computers, as well as automatically loading the program into the computer using Minecraft
                        commands
                    </li>
                </ul>
            </div>
            {isMobile ? <img src={RedstoneComputer}/> : null}
        </div>

        <div className={style.portfolioSectionHorizontalFlex}>
            <div className={isMobile ? style.mobilePortfolioFlexSubsection : style.portfolioFlexSubsection}>
                <h3>Project Pancho</h3>
                <p>📅 July 2024 - December 2024</p>
                <ul>
                    <li>An ARG project created for a Florida Tech organization</li>
                    <ul>
                        <li>Clues were occasionally given to organization members, who had the goal of decoding them
                            to progress further on the website
                        </li>
                    </ul>
                    <li>Made use of a frontend website with connected to a backend server, which interfaced with a
                        MongoDB database to allow for real-time updates to be made to the website as clues were
                        solved.
                    </li>
                    <li>Unfortunately, no longer accessible, as the website was taken down after the ARG had
                        ended.
                    </li>
                </ul>

            </div>
            <img src={PanchoFace}/>
        </div>


        <div className={style.portfolioSectionHorizontalFlex}>
            <div className={isMobile ? style.mobilePortfolioFlexSubsection : style.portfolioFlexSubsection}>
                <h3><a href={''}>The website you are currently on!</a></h3>
                <p>📅 January 2025</p>
                <ul>
                    <li>Made using the React framework</li>
                    <li>Hosted on an AWS EC2 instance using nginx</li>
                </ul>
            </div>
        </div>
    </div>
}